import Vue from 'vue';

import link from './link.vue';
Vue.component('mag-link', link);